<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="DEDICATION para-style-override-1" id="toc_marker-1">For David H. Kelsey<span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Healy_Hauerwas-3.vue?f9b32bda